import Glide from '@glidejs/glide'

export class Dsg {
  constructor() {
    this.init()
  }
  init() {
    this._headerScrollAnimation()
    this._scrollToElement()
    this._consoleMessage()
  }
  /***************************************************************
    CF7 textarea length counter
  ***************************************************************/
  countTextAreaLength(textArea, maxCount) {
    const textarea = textArea
    const maxLength = maxCount
    const parent = textarea.parentNode
    const wpcf7Elm = this.qs('.wpcf7')
    this._createMaxLengthElement(textarea, maxLength)
    let countContainer = this.qs('.text-area-length-count', parent)
    let countDiv = this.qs('.text-area-length-count .left', parent)
    textarea.addEventListener('input', function () {
      const currentLength = this.value.length
      let res = []
      let str = this.value.replace(/[\t\n\r\.\?\!]/gm, ' ').split(' ')
      str.map((s) => {
        let trimStr = s.trim()
        if (trimStr.length > 0) {
          res.push(trimStr)
        }
      })
      countDiv.innerHTML = res.length

      if (res.length > maxLength) {
        countContainer.style.color = 'red'
        textarea.classList.add('wpcf7-not-valid')
      } else {
        countContainer.style.color = ''
        textarea.classList.remove('wpcf7-not-valid')
      }
    })
    wpcf7Elm.addEventListener('wpcf7mailsent', (event) => {
      countDiv.innerHTML = '0'
      countContainer.style.color = ''
      textarea.classList.remove('wpcf7-not-valid')
    })
  }
  /***************************************************************
    Common slider
  ***************************************************************/
  slider(element, autoplay = false, gap = 0, startAt = 0, isCarousel = true) {
    let sliderType = isCarousel ? 'carousel' : 'slider'
    const glides = this.qsa(element)
    glides.forEach((glide) => {
      new Glide(glide, {
        type: sliderType,
        gap: gap,
        startAt: startAt,
        autoplay: autoplay,
        hoverpause: false,
      }).mount()
    })
  }
  /***************************************************************
    Mobile filters for Resources and community
  ***************************************************************/
  mobileFilters(open, container) {
    if (open) {
      container.classList.add('filters-active')
      document.body.classList.add('filters-active')
    } else {
      container.classList.remove('filters-active')
      document.body.classList.remove('filters-active')
    }
  }
  /***************************************************************
    Display Resources filter selected items
  ***************************************************************/
  filterSelectedItems(container, outerContainer, title, searchText = null) {
    container.innerHTML = ''
    const checkedLabel = this.qsa(
      '.searchandfilter [data-sf-field-input-type="checkbox"] input[type="checkbox"]:checked + label',
      outerContainer
    )

    const datePickers = this.qsa('.sf-datepicker', outerContainer)
    const mobileFiltersBtn = this.qs('.mobile-filters-btn')

    const resetContainer = this.qs('.sf-field-reset', outerContainer)
    let viewState = false

    const mediaQuery = window.matchMedia('(min-width:992px)')

    if (mediaQuery.matches) {
      if (checkedLabel.length == 0 && searchText == null) {
        resetContainer.style.display = 'none'
        viewState = false
      } else {
        resetContainer.style.display = 'block'
        viewState = true
      }

      // datePickers.forEach((datePicker) => {
      //   if (datePicker.value) {
      //     resetContainer.style.display = 'block'
      //     console.log(datePicker.value)
      //     viewState = true
      //   }
      // })
    }

    if (title) {
      this.qs('.main-page-title').innerHTML = title
    }

    checkedLabel.forEach((label) => {
      const newSpan = document.createElement('SPAN')
      newSpan.innerHTML = label.textContent
      newSpan.dataset.id = label.getAttribute('for')
      container.prepend(newSpan)
    })

    if (searchText !== null) {
      const newSpan = document.createElement('SPAN')
      newSpan.innerHTML = `<em>Search:</em> <strong>${searchText}</strong>`
      container.prepend(newSpan)
    }
  }
  debounce(cb, delay = 1000) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        cb(...args)
      }, delay)
    }
  }
  matchMedia(cb, media) {
    const screenSize = `(${media})`
    const mediaQuery = window.matchMedia(screenSize)
    if (mediaQuery.matches) {
      return (...args) => {
        cb(...args)
      }
    }
  }
  qs(container, parent = document) {
    return parent.querySelector(container)
  }
  qsa(container, parent = document) {
    return [...parent.querySelectorAll(container)]
  }
  isMobile() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      return true
    } else {
      return false
    }
  }
  /***************************************************************
    Site header scroll animation
  ***************************************************************/
  _headerScrollAnimation() {
    const mainHead = this.qs('#masthead')
    const resourcesNav = this.qs('.resources-navigation')
    const compareSolutionsHeader = this.qs('.compare-solutions__table__labels__head')
    let previousScroll,
      currentScrollTop = 0

    window.addEventListener('scroll', () => {
      const a = document.documentElement.scrollTop
      const b = mainHead.clientHeight
      currentScrollTop = a

      if (a >= b) {
        mainHead.classList.add('site-header--stuck')
      }

      if (a == 0) {
        mainHead.classList.remove('site-header--stuck')
      }

      if (previousScroll < currentScrollTop && a > b + b) {
        mainHead.classList.add('site-header--hide')
        if (resourcesNav) {
          resourcesNav.classList.add('resources-navigation--top')
        }
        if (compareSolutionsHeader) {
          compareSolutionsHeader.classList.add('compare-solutions__table__labels__head--top')
        }
        document.documentElement.style.setProperty('--main-header-height', '0px')
      } else if (previousScroll > currentScrollTop && !(a <= b)) {
        mainHead.classList.remove('site-header--hide')
        if (resourcesNav) {
          resourcesNav.classList.remove('resources-navigation--top')
        }
        if (compareSolutionsHeader) {
          compareSolutionsHeader.classList.remove('compare-solutions__table__labels__head--top')
        }
        document.documentElement.style.setProperty('--main-header-height', '80px')
      }

      previousScroll = currentScrollTop
    })
  }
  _createMaxLengthElement(textarea, maxLength) {
    let countDiv = document.createElement('div')
    countDiv.classList.add('text-area-length-count')
    countDiv.innerHTML = `<span class="left">0</span>/<span>${maxLength}</span>`
    textarea.parentNode.insertBefore(countDiv, textarea.nextSibling)
  }
  _scrollToElement() {
    const scrollToElementBtn = this.qsa('.scroll-to-target')

    if (scrollToElementBtn.length !== 0) {
      scrollToElementBtn.forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault()
          const scrollElementName = element.dataset.target
          let scrollToElement = null

          if (scrollElementName === 'top') {
            scrollToElement = document.body
          } else if (scrollElementName) {
            scrollToElement = this.qs(scrollElementName)
            if (scrollToElement.getBoundingClientRect().top < 0) {
              scrollToElement.style.top = '-120px'
            } else {
              scrollToElement.style.top = '-60px'
            }
          }

          if (scrollToElement) {
            scrollToElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            })
          }
        })
      })
    }
  }
  _consoleMessage() {
    const styles = [
      'color: #3c8197',
      'background: #ffffff',
      'font-size: 30px',
      'border: 1px solid red',
      'text-shadow: 2px 2px black',
      'padding: 10px',
      'border-radius:8px',
    ].join(';')

    const styles2 = [
      'color: #3c8197',
      'background: #ffffff',
      'font-size: 20px',
      'border: 1px solid red',
      'padding: 10px',
      'border-radius:8px',
    ].join(';')

    console.log('%c© DSG HUB 2022.', styles)
    console.log('%cAll rights reserved.', styles2)
  }
}
